import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
    AccountFilter,
    ClientTypeFilter,
    ConstructionTypeFilter,
    EnergyLabelFilter,
    FixedPeriodsFilter,
    LoanFormFilter,
    NHGFilter,
    RiskCategoryFilter,
    SubmitFilter,
} from './Filters';
import Content from './General/Content';
import Filters from './General/Filters';
import InterestFixedPeriodTable from './InterestTables/InterestFixedPeriodTable';

import { FIXED_PERIOD_FILTERS } from '../../Constants/Interest/Filter';

import { disablePdfButton } from '../../Store/Pdf/action';

const InterestFixedPeriod: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(disablePdfButton());
    }, []);

    return (
        <div className="interest-content-wrapper" data-testid="interest-fixed-period">
            <Filters>
                <SubmitFilter filterProperties={FIXED_PERIOD_FILTERS} />
                <hr />
                <FixedPeriodsFilter />
                <hr />
                <LoanFormFilter />
                <hr />
                <RiskCategoryFilter />
                <hr />
                <EnergyLabelFilter />
                <hr />
                <AccountFilter />
                <hr />
                <ConstructionTypeFilter />
                <hr />
                <NHGFilter />
                <hr />
                <ClientTypeFilter />
            </Filters>
            <Content>
                <InterestFixedPeriodTable />
            </Content>
        </div>
    );
};

export default InterestFixedPeriod;
